"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var WidgetManager_1 = require("../../WidgetManager");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var WidgetBehaviours_1 = require("Project/QwilrEditor/Behaviours/WidgetBehaviours");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var AgreementSchema_1 = require("Project/QwilrEditor/Schemas/AgreementSchema");
var WidgetAdderMenu = (function (_super) {
    __extends(WidgetAdderMenu, _super);
    function WidgetAdderMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disposeReaction = function () { };
        _this.addWidgetType = function (type) { return function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("widgetAdder", {
                action: WidgetBehaviours_1.WidgetAction.ClickWidgetAdderItem,
                selectedWidgetType: type,
            }));
        }; };
        _this.renderOption = function (option) {
            var renderedOption = (react_1.default.createElement("div", { className: (0, classnames_1.default)("widget-adder__menu-option", {
                    "widget-adder__menu-option--is-selected": option.isSelected,
                }), key: option.type, onMouseDown: _this.addWidgetType(option.type), onMouseOver: _this.setSelectedOption(option.type) },
                react_1.default.createElement("div", { className: "widget-adder__menu-option-icon center" }, option.icon),
                react_1.default.createElement("div", { className: "widget-adder__menu-option-display" }, option.displayName || option.type),
                option.isBeta && (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, className: "editor-v1 widget-adder__menu-option-beta-tooltip", targetClassName: "widget-adder__menu-option-beta-tooltip-target", content: react_1.default.createElement("div", { className: "widget-adder__menu-option-beta-tooltip-container" },
                        react_1.default.createElement("span", { className: "widget-adder__menu-option-beta-tooltip-title" }, "This is a beta feature"),
                        react_1.default.createElement("span", { className: "widget-adder__menu-option-beta-tooltip-description" }, "If you have any feedback or questions, send us an email at beta@qwilr.com")) },
                    react_1.default.createElement("div", { className: "widget-adder__menu-option-beta" }, "Beta"))),
                option.isNew && (react_1.default.createElement("div", { className: "widget-adder__menu-option-label widget-adder__menu-option-label--new" }, "New"))));
            if (option.tooltip) {
                return (react_1.default.createElement(kaleidoscope_1.Tooltip, { key: option.type, size: kaleidoscope_1.TooltipSize.Large, position: kaleidoscope_1.TooltipPosition.Right, content: option.tooltip, className: "editor-v1 widget-adder__menu-option-description-tooltip" }, renderedOption));
            }
            return renderedOption;
        };
        _this.setSelectedOption = function (type) { return function () {
            _this.props.widgetAdderStore.selectedWidgetType = type;
        }; };
        return _this;
    }
    WidgetAdderMenu.prototype.componentDidMount = function () {
        var _this = this;
        var debouncedTrack = function () {
            _this.props.telemetry.filteredAdderMenu();
        };
        var length = this.props.widgetAdderStore.widgetAdderOptions(this.props.editor).length;
        this.disposeReaction = (0, mobx_1.reaction)(function () { return _this.props.widgetAdderStore.widgetAdderOptions(_this.props.editor).length; }, function (newLength) {
            if (newLength < length && length > 0 && newLength > 0) {
                debouncedTrack();
            }
            length = newLength;
        });
    };
    WidgetAdderMenu.prototype.componentWillUnmount = function () {
        this.disposeReaction && this.disposeReaction();
    };
    WidgetAdderMenu.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "widget-adder__menu-container" },
            react_1.default.createElement("div", { className: "widget-adder__menu center" }, this.filteredOptions.filter(function (option) { return option !== undefined; }).map(this.renderOption))));
    };
    Object.defineProperty(WidgetAdderMenu.prototype, "filteredOptions", {
        get: function () {
            var _a = this.props, widgetAdderStore = _a.widgetAdderStore, editor = _a.editor;
            return widgetAdderStore
                .widgetAdderOptions(editor)
                .filter(function (option) {
                var _a;
                if (((_a = editor.schema) === null || _a === void 0 ? void 0 : _a.name) === AgreementSchema_1.schema.name) {
                    var allowedWidgets = [Types_1.WidgetBlockType.Table];
                    return allowedWidgets.includes(option.type);
                }
                return true;
            })
                .map(function (option) {
                var _a;
                var registryWidgetAdderOption = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(option.type)) === null || _a === void 0 ? void 0 : _a.widgetAdderConfig;
                if (registryWidgetAdderOption) {
                    return __assign(__assign(__assign({}, option), registryWidgetAdderOption), { isSelected: widgetAdderStore.selectedWidgetType === option.type });
                }
                switch (option.type) {
                    case Types_1.WidgetBlockType.Image: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Image, icon: react_1.default.createElement(icons_1.WidgetImage, null) });
                    }
                    case Types_1.WidgetBlockType.Video: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Video, icon: react_1.default.createElement(icons_1.WidgetVideo, null) });
                    }
                    case Types_1.WidgetBlockType.Table: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Table, icon: react_1.default.createElement(icons_1.WidgetTable, null) });
                    }
                    case Types_1.WidgetBlockType.GoogleMaps: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.GoogleMaps, icon: react_1.default.createElement(icons_1.GoogleMaps, null) });
                    }
                    case Types_1.WidgetBlockType.Iframe: {
                        return __assign(__assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Iframe, icon: react_1.default.createElement(icons_1.WidgetIframe, null) }), (0, CommonUtils_1.includeIf)(widgetAdderStore.useEmbedWidgetBranding, {
                            displayName: "embed",
                            tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", __assign({ src: "Assets/Images/embed-tooltip-preview.gif" }, HARDCODED_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
                                react_1.default.createElement("span", null, "Embed documents, presentations, spreadsheets, and more"))),
                        }));
                    }
                    case Types_1.WidgetBlockType.SideBySide: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.SideBySide, icon: react_1.default.createElement(icons_1.WidgetTwoColumns, null) });
                    }
                    case Types_1.WidgetBlockType.Button: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Button, icon: react_1.default.createElement(icons_1.WidgetButton, null) });
                    }
                    case Types_1.WidgetBlockType.ContentLoop: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.ContentLoop, icon: react_1.default.createElement(icons_1.Loop, null) });
                    }
                    case Types_1.WidgetBlockType.ROICalculator: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.ROICalculator, icon: react_1.default.createElement(icons_1.WidgetRoi, null), tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", __assign({ src: "Assets/Images/roi-tooltip-preview.gif" }, HARDCODED_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
                                react_1.default.createElement("span", null, "Highlight ROI value with an interactive calculator"))) });
                    }
                    case Types_1.WidgetBlockType.Accordion: {
                        return __assign(__assign({}, option), { isSelected: widgetAdderStore.selectedWidgetType === Types_1.WidgetBlockType.Accordion, icon: react_1.default.createElement(icons_1.AccordionLeftButton, null), tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("img", __assign({ src: "Assets/Images/accordion-tooltip-preview.gif" }, HARDCODED_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
                                react_1.default.createElement("span", null, "Add foldable content within your blocks"))) });
                    }
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetAdderMenu.prototype, "setSelectedOption", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], WidgetAdderMenu.prototype, "filteredOptions", null);
    WidgetAdderMenu = __decorate([
        mobx_react_1.observer
    ], WidgetAdderMenu);
    return WidgetAdderMenu;
}(react_1.default.Component));
exports.default = WidgetAdderMenu;
var HARDCODED_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS = {
    height: 100,
    width: 168,
};
